import { createSlice } from "@reduxjs/toolkit/";
import { PayloadAction } from "@reduxjs/toolkit";
import { getSecondsUntilUTCDate } from "helper/dateHelper";

export type OtpRecord = {
  id: string;
  userInfo: {
    firstName: string;
    lastName: string;
    email: string;
    yearOfBirth?: string;
    phoneLastFour?: string;
  };
  deviceId: string;
  type: string;
  code: string;
  isShared: boolean;
  isUsed: boolean;
  expiresAt: string;
  expiresIn: number;
  createdAt: string;
};

type OtpRecordStateType = {
  otpRecords: OtpRecord[];
};

const initialState: OtpRecordStateType = {
  otpRecords: [],
};

export const otpRecordSlice = createSlice({
  name: "otpRecords",
  initialState,
  reducers: {
    setOtpRecords: (state, { payload }: PayloadAction<OtpRecord[]>) => {
      if (!Array.isArray(payload)) return;
      state.otpRecords = payload.map((otpRecord: OtpRecord) => {
        return {
          id: otpRecord.id,
          userInfo: otpRecord.userInfo,
          deviceId: otpRecord.deviceId,
          type: otpRecord.type,
          code: otpRecord.code,
          isShared: otpRecord.isShared,
          isUsed: otpRecord.isUsed,
          expiresAt: otpRecord.expiresAt,
          expiresIn: getSecondsUntilUTCDate(otpRecord.expiresAt),
          createdAt: otpRecord.createdAt,
        };
      });
    },
  },
});

export const { setOtpRecords } = otpRecordSlice.actions;
